<template>
  <div class="test" :class="slug">
    <nav
      v-if="slug === 'home' || section === 'explore'"
      class="page-nav"
    >
      <router-link :to="{ name: 'blogs', params: { slug, section } }">Overview</router-link>
      <router-link v-if="slug === 'home'" :to="{ name: 'page-inspiration', params: { slug } }">Inspiration</router-link>
      <router-link v-if="section === 'explore'" :to="{ name: 'explore', params: { slug, section } }">Explore</router-link>
    </nav>
    <blog-form v-model="blog" />
  </div>
</template>

<script>
import BlogForm from '@/components/forms/BlogForm'
export default {
  data () {
    return {
      blog: {}
    }
  },

  props: {
    slug: {
      type: [String]
    },
    section: {
      type: [String],
      default: ''
    }
  },

  components: {
    BlogForm
  },

  created () {
    // const url = this.section ? `blog-posts/${this.section}/${this.slug}` : `blog-posts/${this.slug}`
    const url = `blog-posts/${this.slug}`
    this.axios.get(url)
      .then(res => {
        this.blog = res.data

        this.blog.related_tours = this.blog.related || []
      })
  }
}
</script>
